import { memo } from 'react';
import { default as css } from './RoundedText.module.scss';
import classNames from 'classnames';
import { RoundedTextProps } from './RoundedText.types';

export const RoundedText = memo(({
    ariaLabel,
    text,
    styleType,
    size,
}: RoundedTextProps) => {
    return <div aria-label={ariaLabel} className={classNames(css.roundedText, css[styleType], css[size])}>{text}</div>;
});
